import { LabFeature } from '@fabric-app/types/labs';

const LABS_FEATURES = {
  [LabFeature.SMART_COLLECTIONS]: {
    label: "Smart collections",
    description: "A collection which automatically gathers your content based on prompt.\nYou can also create one by saving a search.",
    default: true
  }
};

export { LABS_FEATURES };
//# sourceMappingURL=labs.config.js.map
